
import React from 'react';
import quoteIcon from'../assets/quote.png';
import GridImage from "../assets/right-grid1.png"; 
import lightTick from "../assets/icons/light-tick.svg";
import border from "../assets/icons/border.svg";
import darkTick from "../assets/icons/dark-tick.svg";
import WebDevelopmentImage from "../assets/web-dev-preview.webp";
import underline from '../assets/underlinee.png';
import { motion } from "framer-motion";
import iconUX from "../assets/icon-uxx.svg";
import iconEngagement from "../assets/icon-engagementt.svg";
import iconUI from "../assets/icon-uii.svg";
import { Helmet } from "react-helmet-async";

const WebDevelopmentSection = () => {

const features = [
  {
    image: iconUX,
    bg: "bg-[#FFE5E5]",
    title: "User experience",
    description:
      "By providing performance even in low-connectivity settings, these apps improve user experience & accessible.",
  },
  {
    image: iconEngagement,
    bg: "bg-[#E3F5FF]",
    title: "User engagement",
    description:
      "By providing experiences & optimizing information according to user behavior and preferences in real time.",
  },
  {
    image: iconUI,
    bg: "bg-[#FFF6D7]", // soft yellow background
    title: "User interface",
    description:
      "Responsive apps deliver a consistent user experience across PCs, tablets, and smartphones.",
  },
];

const benefitCards = [
  { bg: true, text: "Increased user experience and engagement." },
  { bg: false, text: "Enable seamless upgrades and enhancements in the future." },
  { bg: true, text: "Streamline operations with backend and API integrations." },
  { bg: false, text: "Protect sensitive data and ensure compliance." },
  { bg: true, text: "Ensure fast load times and smooth user experience." },
  { bg: false, text: "Ensure seamless performance across all devices and browsers." },
  { bg: true, text: "Interactive features increase app usage and engagement." },
  { bg: false, text: "Easy, free navigation is guaranteed with a user-friendly design." },
  { bg: true, text: "Personalized data improves retention and relevancy." },
];

  return (
    <>
    
<Helmet>
        <title>Web Development Services | Scalable & Responsive Solutions by Lentera</title>
        <meta name="description" content="Lentera Technologies builds secure, scalable, and responsive web applications with custom design, strong performance, and seamless cross-platform experiences."/>
        <meta name="keywords" content="Lentera Technologies, custom web applications, responsive web design, scalable web solutions, secure web apps, UI/UX design, web app performance, cross-platform web apps."/>
      </Helmet>

     <section className="w-full bg-[#FAFAFA] py-20 px-4 sm:px-6">
  <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
    
    {/* Left Column – 60% with animation */}
    <motion.div
      className="w-full lg:w-[60%]"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <h5 className="text-[#009c3c] text-sm font-semibold uppercase mb-3 tracking-wide">
        Web Development
      </h5>

      <h2 className="text-[#1E1E1E] text-[40px] md:text-[48px] font-extrabold leading-tight mb-6">
        Power your brand <br className="hidden sm:block" /> with expert
      </h2>

      <p className="text-[#4A4A4A] text-base leading-relaxed max-w-[580px]">
        Web development builds dynamic, responsive websites tailored to your brand and goals. It ensures seamless user experiences, strong performance, and a powerful online presence.
      </p>
    </motion.div>

    {/* Right Column – 40% with animation */}
    <motion.div
      className="w-full lg:w-[40%] flex justify-center"
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
    >
      <img
        src={WebDevelopmentImage}
        alt="Web Developer Illustration"
        className="w-full max-w-[500px] h-auto object-contain"
      />
    </motion.div>

  </div>
</section>




<section className="w-full bg-[#DDE7FA] py-20 px-4">
  <div className="w-full max-w-[1440px] mx-auto min-h-[399px]">
    {/* Heading */}
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="mb-16"
    >
      <h2 className="text-[32px] sm:text-[40px] font-semi text-[#1E1E1E]">
        What is web development & it’s overview
      </h2>
      <img
        src={underline}
        alt="Underline"
        className="mt-2 w-[110px] h-[12px] object-contain"
      />
    </motion.div>

    {/* Quotes */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {[0, 1].map((item, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: index * 0.2 }}
          viewport={{ once: true }}
          className="relative bg-white rounded-3xl shadow-lg p-8 sm:p-10 flex items-center justify-center text-center min-h-[240px]"
        >
          <img
            src={quoteIcon}
            alt="Quote Icon"
            className={`absolute -top-4 ${index === 0 ? 'left-4' : 'right-4 rotate-180'} w-6 sm:w-8`}
          />
          <p className="text-[#444444] text-base sm:text-lg italic leading-relaxed max-w-[90%]">
            {index === 0
              ? `“ Web app development delivers customized, scalable, and secure applications tailored to your business needs. It covers everything from intuitive UI design to robust backend systems for smooth, cross-platform performance. This approach ensures your apps meet current demands and are ready for future growth and upgrades. “`
              : `“ We provide custom, scalable, and secure web applications tailored to meet business needs, ensuring seamless performance and enhanced user experience. “`}
          </p>
        </motion.div>
      ))}
    </div>
  </div>
</section>



 <section className="w-full bg-white flex justify-center py-20 px-4 font-poppins">
      <div className="w-[1312px] flex flex-col lg:flex-row items-start justify-between gap-12">
        {/* Left Content */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="w-full lg:w-[60%]"
        >
          <h2 className="text-[44px] font-extrabold text-[#1e1e1e] leading-tight">
            What are the best parts <br /> in web development?
          </h2>

          <div className="mt-4 mb-6 w-[108px] h-[2px] bg-[#00C853] rounded" />

          <p className="text-[#333] text-base leading-relaxed mb-12 max-w-xl">
            The process of developing dynamic and interactive online applications
            that function flawlessly on a variety of devices.
          </p>

          <div className="flex flex-col md:flex-row gap-12">
            {/* Process */}
           <div className="md:pr-8 md:border-r border-gray-200 h-[130px] top-[30px] ">
           

              <h3 className="text-xl font-semibold text-[#1e1e1e] mb-3">Process</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Our Web App development process at Lentera includes responsive development,
                personalized design, and in-depth consulting to make sure every solution fits
                with specific corporate objectives.
              </p>
            </div>

            {/* Purpose */}
            <div className="md:pl-6">
              <h3 className="text-xl font-semibold text-[#1e1e1e] mb-3">Purpose</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Building scalable, secure, and high-performing web applications that are easily
                accessible, effective, and tailored to certain business objectives is the main
                objective of the process.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div
  initial={{ opacity: 0, scale: 0.95 }}
  whileInView={{ opacity: 1, scale: 1 }}
  transition={{ duration: 0.6, delay: 0.2 }}
  viewport={{ once: true }}
  className="w-full lg:w-[50%] flex justify-center items-center"
>
  <img
    src={GridImage}
    alt="Grid Illustration"
    className="w-[800px] h-[452px] object-contain"
  />
</motion.div>

      </div>
    </section>
    
    
      
  <section className="bg-[#131519] py-6 md:py-8 lg:py-12 px-4 text-white">
  {/* Header */}
  <div className="mx-auto text-center mb-6 md:mb-8 lg:mb-12">
    <motion.h2
      className="text-[24px] sm:text-[36px] lg:text-[48px] font-extrabold leading-tight mb-4 md:mb-6 lg:mb-8"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      Benefits of using <br className="hidden sm:block" /> web development
    </motion.h2>

    <motion.p
      className="text-gray-300 text-base text-sm md:text-[16px] xl:text-lg leading-tight md:leading-[24px]"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
    >
      Maximize your business potential with custom-built, high-performance software solutions
    </motion.p>
  </div>

  {/* Grouped Cards Image */}
  <motion.div
    className="flex flex-wrap justify-center gap-4 text-[#212129] font-medium"
    initial={{ opacity: 0, scale: 0.95 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.6, delay: 0.3 }}
    viewport={{ once: true }}
  >
    {benefitCards.map((card) => (
      <div className={`
          ${card.bg ? "bg-[#29E98A]" : "bg-white"}
          p-6 rounded-2xl flex flex-col min-w-[250px] basis-full sm:basis-[40%] lg:basis-[20%] xl:basis-[19%]
        `}
      >
        <div className={`w-12 h-12 mb-4 rounded-full flex justify-center items-center ${card.bg ? "bg-white" : "bg-[#DAFFED]"}`}>
          <img src={card.bg ? darkTick : lightTick} alt="tick" className="w-6 h-6" />
        </div>

        <p className="text-sm md:text-[16px] xl:text-lg leading-tight md:leading-[24px] font-semibold mb-4">{card.text}</p>

        {card.bg && <img src={border} className='w-1/3' />}
      </div>
    ))}
  </motion.div>

</section>

   <section className="bg-white py-20 px-4 font-poppins w-full">
      <div className="max-w-7xl mx-auto text-center">
        {/* Heading */}
        <h2 className="text-[40px] md:text-[48px] font-extrabold text-[#1E1E1E] mb-4 leading-snug">
          Innovations in web app <br /> development
        </h2>
        <p className="text-lg text-gray-500 mb-16">
          Unlock the full potential of your business with powerful, tailor-made software solutions!
        </p>

        {/* Features */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              whileHover={{
                scale: 1.05,
                boxShadow: "0px 12px 25px rgba(0, 0, 0, 0.08)",
              }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              className="bg-white border border-gray-200 rounded-2xl p-8 text-center shadow-sm cursor-pointer"
            >
              {/* Icon with background circle */}
              <div className="w-20 h-20 mx-auto mb-6 relative flex items-center justify-center">
                {/* <div
                  className={`absolute w-[60px] h-[60px] rounded-full ${feature.bg}`}
                ></div> */}
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-20 h-20 relative z-10"
                />
              </div>

              <h3 className="text-xl font-semibold text-[#1E1E1E] mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
 
</>
  );
};

export default WebDevelopmentSection;
